// @ts-strict-ignore
import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { loadableReady } from '@loadable/component'
import App from './app'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

const cache = createCache({ key: 'ev' })

loadableReady(() => {
  hydrateRoot(
    document.getElementById('app'),
    <CacheProvider value={cache}>
      <App evCoreState={window.__initialState__.evCoreState} />
    </CacheProvider>,
  )
})

if (module.hot) {
  module.hot.accept()
}
